// Single switch between the local mock adapter (mock/server.js) and the
// real BE, reached through the Rails knowledge proxy (see http.js).
// Integration with the real BE was always meant to be "flip this flag" —
// every caller (store actions, components) only ever imports the thin
// functions in properties.js/units.js/etc., never http.js or mock/
// directly, so nothing above this layer needed to change either way. The
// external BE's real-estate endpoints went live on staging
// (saas-singabot.dahreply.ai, confirmed against its live OpenAPI schema
// via scripts/sync_knowledge_api_spec.sh — every path this client calls
// matches 1:1) on 2026-09-28, so this now defaults to the real BE.
//
// A localStorage override still lets anyone flip back to the mock in a
// running app without a rebuild: `localStorage.setItem('re.useMock',
// 'true')` then reload — useful for working on this module without a
// staging-connected server, or once the mock's Layer 1-3 (Milestone 2)
// stub data outruns what the real BE actually enforces.
function readOverride() {
  try {
    const stored = window.localStorage.getItem('re.useMock');
    if (stored === 'true') return true;
    if (stored === 'false') return false;
  } catch (e) {
    // localStorage can throw (private browsing, disabled storage) — fall
    // through to the default below.
  }
  return null;
}

const DEFAULT_USE_MOCK = false;

const override = readOverride();
export const USE_MOCK = override === null ? DEFAULT_USE_MOCK : override;
